import http from '@/utils/http';
export default {detail:async data=>{const response=await http({url:'/api/admin/v1/contractProjectOrderLoadCorrection/detail',method:'post',data});if(response?.code!==0)throw Error(response?.msg||response?.message||'实装更正证据读取失败');return response.data;}};
